import React, { useRef, useEffect } from "react";

export default function UiExperienceVideo(props) {
    // const videoEl = useRef(null);
    // const attemptPlay = () => {
    //     videoEl &&
    //         videoEl.current &&
    //         videoEl.current.play().catch((error) => {
    //             console.error("Error attempting to play", error);
    //         });
    // };

    // useEffect(() => {
    //     attemptPlay();
    //     // window.addEventListener("scroll", () => {
    //     //     let scrollTop = window.scrollY;

    //     //     if (scrollTop >= 500) {
    //     //         // attemptPlay();
    //     //     }
    //     // });
    // }, []);

    return (
        <>
            <div className="sb-experince-video">
                <video
                    width={props.width}
                    height={props.height}
                    playsInline
                    controls
                    loop
                    muted
                    autoPlay
                    // ref={videoEl}
                >
                    <source src={props.video} type="video/mp4" />
                </video>
               
                </div>
        </>
    );
}
